/**
 * Image
 */

import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components/macro";

const baseStyles = ({ background, useAsBackground }) => css`
  width: 100%;
  height: auto;
  background: ${background && background};
  display: block;
  img {
    display: block;
    width: 100%;
    height: auto;
  }
`;

const pa = css`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  height: 100%;
`;

const useAsBackgroundStyles = ({ background }) => css`
  object-fit: cover;
  object-position: center;
  max-height: unset;
  max-width: unset;
  background: ${background || "grey"};
  height: 100%;
`;

const StyledPicture = styled.picture`
  ${baseStyles}
  ${({ useAsBackground }) =>
    useAsBackground &&
    css`
      ${pa}
      img {
        ${useAsBackgroundStyles}
      }
    `}
`;

const StyledImage = styled.img`
  ${baseStyles}
  ${({ useAsBackground }) =>
    useAsBackground &&
    css`
      ${pa}
      ${useAsBackgroundStyles}
    `}
`;

const Image = ({
  src,
  sources,
  alt,
  width,
  height,
  lazy,
  background,
  className,
  useAsBackground,
}) => {
  return (
    <>
      {sources.length > 1 ? (
        <StyledPicture
          background={background}
          useAsBackground={useAsBackground}
          className={className}
        >
          {sources.map((item, index) => {
            return (
              <source
                key={`${item.srcset}-${index}`}
                media={item.media}
                srcSet={item.srcset}
                sizes={item.sizes}
              />
            );
          })}
          <img
            width={width}
            height={height}
            src={src}
            alt={alt}
            loading={lazy && "lazy"}
          />
        </StyledPicture>
      ) : (
        <StyledImage
          srcSet={sources.length > 0 ? sources[0].srcset : undefined}
          sizes={sources.length > 0 ? sources[0].sizes : undefined}
          src={src}
          alt={alt}
          width={width}
          height={height}
          loading={lazy && "lazy"}
          background={background}
          useAsBackground={useAsBackground}
          className={className}
        />
      )}
    </>
  );
};

Image.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  sources: PropTypes.arrayOf(
    PropTypes.shape({
      srcset: PropTypes.string,
      sizes: PropTypes.string,
      media: PropTypes.string,
    })
  ),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

Image.defaultProps = {
  sources: [],
  lazy: true,
};

export default Image;
